import React from 'react';

/**
 * BLOCK: statement_list
 * ACF layout name: `block_statement_list`
 *
 * Fields:
 *  - statements (repeater: statement_text)
 *  - accent     (select: rose | sage)
 *
 * A bordered list of short declarative lines, set in serif rather than as
 * bulleted body copy. Used for the "What I believe" section on Meet Milangela.
 */

interface StatementListProps {
  statements: readonly string[];
  accent?: 'rose' | 'sage';
  className?: string;
}
export function StatementList({
  statements,
  accent = 'rose',
  className = ''
}: StatementListProps) {
  const border = accent === 'rose' ? 'border-rose/50' : 'border-sage/40';
  return <ul className={`border-y ${border} ${className}`} data-id="element-205" data-mp="1pitxu3pzwlro">
      {statements.map(statement => <li key={statement} className={`border-b ${border} py-5 font-serif text-xl leading-snug text-charcoal last:border-b-0 sm:text-2xl`} data-id="element-206" data-mp="1lijjo3s1up1q">
          {statement}
        </li>)}
    </ul>;
}